export default __webpack_public_path__ + "static/media/spectrophotometer-info-1.22b1a453.svg";